import * as React from "react";
import { Tooltip as MuiTooltip } from "@mui/material";
import {AonColors} from "../../../../css/Colors";

export interface ITooltipProps {
    hoverText: string[];
    label?: string;
    iconClass?: string;
    hoverTitle?: string;
    hoverSubtitle?: string;
}

export const Tooltip: React.FunctionComponent<ITooltipProps> = (props) => {
    const hoverText = props.hoverText
        .map((line, index) => <ul key={index}>{line}</ul>);

    return (
        <MuiTooltip
            title={
                <div>
                    {props.hoverTitle && <div className={"tooltip__title"} data-testid={"tooltip__title"}>{props.hoverTitle}</div>}
                    {props.hoverSubtitle && <div className={"tooltip__sub-title"} data-testid={"tooltip__sub-title"}>{props.hoverSubtitle}</div>}
                    {props.hoverText.some(Boolean) &&
                        <div className={"tooltip__text"} data-testid={"tooltip__text"}>{hoverText}</div>}
                </div>
            }
            slotProps={{
                popper: {
                    sx: {
                        '& .MuiTooltip-tooltip': {
                            backgroundColor: AonColors.ActualWhite,
                            border: `1px solid ${AonColors.AonGray05}`,
                            borderRadius: "4px",
                            boxShadow: `0 0 16px ${AonColors.AonGray08}`,
                            padding: "20px",
                            maxHeight: "420px",
                            overflow: "auto",
                        },
                    },
                },
            }}
            data-testid="tooltip__container"
        >
            <span>
                {props.iconClass && <i className={props.iconClass} data-testid="tooltip__icon"/>}
                {props.label && <div>{props.label}</div>}
            </span>
        </MuiTooltip>
    );
};